import { endPoints, methods } from "../environment"
import generateApiSliceAndThunk from "../thunk"

const { slice: trendingArticlesSlice, request: trendingArticlesRequest } =
  generateApiSliceAndThunk(
    "trendingArticlesSlice",
    endPoints.trendingArticles,
    methods.get
  )
const { slice: platformListSlice, request: getPlatformsRequest } =
  generateApiSliceAndThunk(
    "platformListSlice",
    endPoints.platformsList,
    methods.get
  )
const { slice: searchArticlesSlice, request: searchArticlesRequest } =
  generateApiSliceAndThunk(
    "searchArticlesSlice",
    endPoints.searchArticles,
    methods.get
  )
const { slice: platformCategoriesSlice, request: platformCategoriesRequest } =
  generateApiSliceAndThunk(
    "platformCategoriesSlice",
    endPoints.getPlatformCategories,
    methods.get
  )
const {
  slice: categorySpecificArticlesSlice,
  request: categorySpecificArticlesRequest,
} = generateApiSliceAndThunk(
  "categorySpecificArticlesSlice",
  endPoints.categorySpecificArticles,
  methods.get
)

const {
  slice: possibleSolutionsForIssue,
  request: possibleSolutionsForIssueRequest,
} = generateApiSliceAndThunk(
  "possibleSolutionsForIssue",
  endPoints.possibleSolutionsForIssue,
  methods.get
)


const { slice: getArticleSlice, request: getArticleRequest } =
  generateApiSliceAndThunk("getArticleSlice", endPoints.getArticle, methods.get)

export {
  categorySpecificArticlesRequest,
  categorySpecificArticlesSlice,
  getArticleRequest,
  getArticleSlice,
  getPlatformsRequest,
  platformCategoriesRequest,
  platformCategoriesSlice,
  platformListSlice,
  searchArticlesRequest,
  searchArticlesSlice,
  trendingArticlesRequest,
  trendingArticlesSlice,
  possibleSolutionsForIssue,
  possibleSolutionsForIssueRequest
}
